import React, { Component } from "react";
import { hot } from "react-hot-loader";
import { connect } from "react-redux";
import { Modal, ModalBody, Spinner } from "reactstrap";
import { FolderList } from "./FolderList";
import PageWrapper from "../../Utilities/TemplateWrappers/PageTemplate";
import { TabDataTable } from "./TabDataTable";
import { AddFolderModal } from "./modals/AddFolderModal";
import { RemoveFileModal } from "./modals/RemoveFileModal";
import { UploaderModal } from "./modals/UploaderModal";
import { MoveFilesModal } from "./modals/MoveFilesModal";
import { SnackBar } from "./snackbars/snackbar";
import OptionIcon from "@material-ui/icons/Settings";

import SearchIcon from "@material-ui/icons/Search";
import {
    Button,
    Typography,
    TextField,
    Grid,
    Menu,
    IconButton,
    MenuItem,
} from "@material-ui/core";

import {
    setSearchVal,
    setRows,
    setPage,
    redirectTo,
    getFiles,
    getFolders,
    createFolder,
    uploadFile,
    setFolder,
    removeFile,
    setSelected,
    moveFiles,
    getPoliciesLength,
} from "./actions";

import {
    selectSearchVal,
    selectTableData,
    selectRows,
    selectPage,
    selectFiles,
    selectFolders,
    selectedFolder,
    getRequesting,
    canUpdate,
    canCreate,
    canDelete,
} from "./selectors";

class FileManager extends Component {
    constructor(props) {
        super(props);
        props.getFiles();
        props.getFolders();
        props.getPoliciesLength();
        this.state = {
            createFolderModal: false,
            uploadFileModal: false,
            searchVal: "",
            setStatusJobIDInfo: {
                job_pack_id: "",
                title: "",
                address: "",
                status: "",
                start_date: "",
                end_date: "",
            },
            maxSizeExceeded: false,
            createFolderSuccess: false,
            createFolderFail: false,
            anchorEl: null,
            files: false,
            selectedItems: false,
            moveFilesModal: false,
            moveFilesSuccess: false,
            moveFilesFail: false,
            fileExists: false,
        };
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.files !== this.state.files) {
            this.setState({ files: this.props.files });
        }
    }
    checkIfSelected() {
        if (this.state.files) {
            let flag = false;
            this.state.files.map((e) => {
                if (e.selected) flag = true;
                return null;
            });
            return flag;
        } else return false;
    }
    handleClick = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };
    render() {
        const { anchorEl } = this.state;

        return (
            <PageWrapper label="File Manager">
                <Modal
                    isOpen={this.props.requesting}
                    style={{ maxWidth: "00px" }}
                >
                    <ModalBody>
                        <div
                            style={{
                                textAlign: "center",
                                paddingTop: "3em",
                            }}
                        >
                            <div
                                style={{
                                    background: "white",
                                    width: "fit-content",
                                    display: "inline-block",
                                    padding: "2em",
                                }}
                            >
                                <Spinner
                                    style={{
                                        height: 100,
                                        width: 100,
                                        background: "white",
                                    }}
                                    color="primary"
                                />
                                <Typography
                                    style={{
                                        textAlign: "center",
                                        marginTop: 15,
                                        color: "rgba(0, 0, 0, 0.87)",
                                        fontWeight: "bolder",
                                        fontSize: 20,
                                    }}
                                    variant="body2"
                                >
                                    Processing...
                                </Typography>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
                <div style={{ float: "left" }}>
                    <Button
                        onClick={() => {
                            this.setState({
                                uploadFileModal: true,
                            });
                        }}
                        style={{ marginTop: "11px" }}
                        disabled={
                            !this.props.activeFolder ||
                            this.props.activeFolder === "all_files"
                        }
                        color="primary"
                        variant="contained"
                    >
                        Add File
                    </Button>
                </div>
                &nbsp;&nbsp;
                <div
                    style={{
                        width: "50%",
                        float: "left",
                        display: "flex",
                        justifyContent: "space-between",
                        background: "#eee",
                        marginLeft: "30px",
                    }}
                >
                    <TextField
                        onChange={(event) => {
                            this.setState({
                                searchVal: event.target.value,
                            });
                        }}
                        InputProps={{
                            disableUnderline: true,
                        }}
                        fullWidth
                        placeholder={"Search Files"}
                        style={{
                            borderBottom: "0px",
                            minWidth: 225,
                            minHeight: "100%",
                            margin: 12,
                            background: "transparent",
                        }}
                        value={this.state.searchVal}
                    />
                    <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            this.props.setSearchVal(this.state.searchVal);
                        }}
                        style={{ borderRadius: 0 }}
                    >
                        <SearchIcon />
                    </Button>
                </div>
                {this.checkIfSelected() && (
                    <div style={{ width: "inherit", float: "right" }}>
                        <IconButton
                            aria-owns={anchorEl ? "simple-menu" : undefined}
                            aria-haspopup="true"
                            onClick={this.handleClick}
                            style={{ float: "right" }}
                        >
                            <OptionIcon />
                        </IconButton>
                        <Menu
                            id="simple-menu"
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={this.handleClose}
                        >
                            {this.props.canUpdate && (
                                <MenuItem
                                    onClick={() => {
                                        this.setState({
                                            selectedItems: this.state.files,
                                            moveFilesModal: true,
                                        });
                                        this.handleClose();
                                    }}
                                >
                                    Move
                                </MenuItem>
                            )}
                        </Menu>
                    </div>
                )}
                <Grid container spacing={24}>
                    <FolderList
                        folders={this.props.folders}
                        setFolder={this.props.setFolder}
                        activeFolder={this.props.activeFolder}
                        createFolder={() => {
                            this.setState({
                                createFolderModal: true,
                            });
                        }}
                    />
                    <TabDataTable
                        files={this.state.files}
                        rows={this.props.rows}
                        page={this.props.page}
                        setPage={this.props.setPage}
                        setRows={this.props.setRows}
                        removeFile={(e) => {
                            this.setState({
                                removeFile: e,
                                removeFileModal: true,
                            });
                        }}
                        setSelected={(files) => {
                            this.setState({ files });
                        }}
                    />
                </Grid>
                <AddFolderModal
                    createFolder={this.props.createFolder}
                    folderName={this.state.folderName}
                    createFolderModal={this.state.createFolderModal}
                    setName={(folderName) => {
                        this.setState({
                            folderName,
                        });
                    }}
                    setModalView={(createFolderModal) => {
                        this.setState({ createFolderModal });
                    }}
                    setFolderSuccess={(createFolderSuccess) => {
                        this.setState({ createFolderSuccess });
                    }}
                    setFolderFail={(createFolderFail) => {
                        this.setState({ createFolderFail });
                    }}
                />
                <RemoveFileModal
                    closeModal={() => {
                        this.setState({
                            removeFileModal: false,
                            removeFile: false,
                        });
                    }}
                    removeFail={(
                        removeFileModal,
                        removeFileFail,
                        removeFile
                    ) => {
                        this.setState({
                            removeFileModal,
                            removeFileFail,
                            removeFile,
                        });
                    }}
                    removeSuccess={(
                        removeFileModal,
                        removeFileSuccess,
                        removeFile
                    ) => {
                        this.setState({
                            removeFileModal,
                            removeFileSuccess,
                            removeFile,
                        });
                    }}
                    removeFile={this.props.removeFile}
                    files={this.state.files}
                    removeFileModal={this.state.removeFileModal}
                />
                <UploaderModal
                    closeModal={() => {
                        this.setState({
                            uploadFileModal: false,
                        });
                    }}
                    error={(fileFail) => {
                        this.setState({
                            fileFail,
                        });
                    }}
                    fileExists={(fileFail) => {
                        this.setState({
                            fileFail,
                        });
                    }}
                    success={(uploadFileModal, fileSuccess, fileProgress) => {
                        this.setState({
                            uploadFileModal,
                            fileSuccess,
                            fileProgress,
                        });
                    }}
                    inProgress={(progress) => {
                        this.setState({
                            progress,
                        });
                    }}
                    uploadFile={this.props.uploadFile}
                    uploadFileModal={this.state.uploadFileModal}
                    activeFolder={this.props.activeFolder}
                    allFiles={this.props.allFiles}
                    maxSize={(exceeded) => {
                        this.setState({
                            maxSizeExceeded: exceeded,
                        });
                    }}
                />
                <MoveFilesModal
                    moveFilesModal={this.state.moveFilesModal}
                    setModalView={(moveFilesModal) => {
                        this.setState({
                            moveFilesModal,
                        });
                    }}
                    error={(fileMovesFail) => {
                        this.setState({
                            fileMovesFail,
                        });
                    }}
                    onSuccess={(moveFilesSuccess) => {
                        this.setState({
                            moveFilesSuccess,
                        });
                    }}
                    moveFiles={this.props.moveFiles}
                    folders={this.props.folders}
                    files={this.state.files}
                />
                <SnackBar
                    success={this.state.moveFilesSuccess}
                    fail={this.state.moveFilesFail}
                    close={() => {
                        this.setState({
                            moveFilesFail: false,
                            moveFilesSuccess: false,
                        });
                    }}
                    successMessage={"Files have successfully been moved!"}
                    failMessage={
                        "Unable to move all files, some files still may have been moved, Please Contact System Admin With Folder Details!"
                    }
                />
                <SnackBar
                    success={this.state.createFolderSuccess}
                    fail={this.state.createFolderFail}
                    close={() => {
                        this.setState({
                            createFolderFail: false,
                            createFolderSuccess: false,
                        });
                    }}
                    successMessage={"New Folder Created!"}
                    failMessage={
                        "Unable to create folder, Please Contact System Admin With Folder Details!"
                    }
                />
                <SnackBar
                    success={this.state.removeFileSuccess}
                    fail={this.state.removeFileFail}
                    close={() => {
                        this.setState({
                            removeFileFail: false,
                            removeFileSuccess: false,
                        });
                    }}
                    successMessage={"File has been removed!"}
                    failMessage={
                        "Unable to remove file, Please Contact System Admin With File Details!"
                    }
                />
                <SnackBar
                    success={false}
                    fail={this.state.maxSizeExceeded}
                    close={() => {
                        this.setState({
                            maxSizeExceeded: false,
                        });
                    }}
                    successMessage={""}
                    failMessage={"Cannot upload file, file size exceeds 10mb!"}
                />
                <SnackBar
                    success={false}
                    fail={this.state.fileExists}
                    close={() => {
                        this.setState({
                            fileExists: false,
                        });
                    }}
                    successMessage={""}
                    failMessage={
                        "Cannot upload file, file already exists! To upload, change file name and retry upload!"
                    }
                />
                <SnackBar
                    success={this.state.fileSuccess}
                    fail={this.state.fileFail}
                    close={() => {
                        this.setState({
                            fileFail: false,
                            fileSuccess: false,
                        });
                    }}
                    successMessage={"File has been successfully uploaded!"}
                    failMessage={
                        "Unable to upload file, Please Contact System Admin With Details!"
                    }
                />
            </PageWrapper>
        );
    }
}

export default hot(module)(
    connect(
        (store) => {
            return {
                files: selectTableData(store),
                searchVal: selectSearchVal(store),
                rows: selectRows(store),
                page: selectPage(store),
                allFiles: selectFiles(store),
                folders: selectFolders(store),
                activeFolder: selectedFolder(store),
                requesting: getRequesting(store),
                canUpdate: canUpdate(store),
                canCreate: canCreate(store),
                canDelete: canDelete(store),
            };
        },
        {
            setFolder,
            setSearchVal,
            setRows,
            setPage,
            createFolder,
            redirectTo,
            getFiles,
            getFolders,
            uploadFile,
            removeFile,
            setSelected,
            moveFiles,
            getPoliciesLength,
        }
    )(FileManager)
);
